import { accent } from "../hooks/tokens.js";
import { EXAMS, COURSES } from "../data.js";

// Préparation certif : score pondéré par domaine, priorités de révision,
// historique des tentatives. `pct` par domaine vient toujours de
// pctForDomain (quiz_sessions) — EXAMS ne porte que le poids/libellé.
export function buildCertifView(ctx) {
  const { s, patch, practiceDomain, pctForDomain, attemptedDomain } = ctx;
  const ex = EXAMS.find((e) => e.id === s.certifId) || EXAMS[0];
  const domains = ex.domains.map((d, i) => ({ ...d, pct: pctForDomain(ex.id + ":" + i), domainId: ex.id + ":" + i }));
  const score = domains.reduce((n, d) => n + d.w * d.pct / 100, 0);
  const impact = (d) => d.w * (100 - d.pct) / 100;
  const ranked = domains.slice().sort((a, b) => impact(b) - impact(a));
  const recentAttempts = s.quizSessions
    .filter((x) => x.domainId.startsWith(ex.id + ":"))
    .slice(-6).reverse()
    .map((x) => {
      const mi = Number(x.domainId.split(":")[1]);
      const mod = COURSES.find((c) => c.id === ex.id)?.modules[mi];
      return { label: mod ? mod.title : x.domainId, score: x.scorePct + " %",
        color: x.scorePct >= 70 ? accent : "oklch(0.5 0.09 30)" };
    });

  return {
    certifTabs: EXAMS.map((e) => ({ label: e.label,
      border: e.id === s.certifId ? accent : "oklch(0.92 0.008 85)",
      color: e.id === s.certifId ? accent : "oklch(0.45 0.015 60)",
      bg: e.id === s.certifId ? "oklch(0.99 0.006 60)" : "transparent",
      onClick: () => patch({ certifId: e.id }) })),
    certifExam: ex.label, certifDate: ex.date,
    certifScore: Math.round(score) + " %",
    certifScoreColor: score >= 82.5 ? accent : "oklch(0.3 0.015 60)",
    certifDomains: domains.map((d) => ({ name: d.name, detail: d.detail, weight: d.weight, pct: d.pct,
      color: d.pct >= 70 ? accent : d.pct >= 45 ? "oklch(0.52 0.06 70)" : "oklch(0.55 0.09 30)",
      gap: "−" + Math.round(impact(d)) + " pts",
      gapColor: impact(d) >= 10 ? "oklch(0.5 0.09 30)" : "oklch(0.53 0.015 60)",
      onClick: () => practiceDomain(d.domainId) })),
    certifPriorities: ranked.slice(0, 3).map((d) => ({
      title: d.name,
      why: d.weight + " de l'examen, maîtrise " + d.pct + " % (" + (attemptedDomain(d.domainId) ? "quiz tenté" : "quiz jamais tenté") + ")",
      onClick: () => practiceDomain(d.domainId) })),
    certifAttempts: recentAttempts.length ? recentAttempts : [{ label: "Aucun quiz tenté pour l'instant", score: "—", color: "oklch(0.53 0.015 60)" }],
  };
}
